import { queryOptions } from "@tanstack/react-query";
import {
  getBatchVendors,
  showQuotationBatch,
} from "../../../../../__generated__/orval/endpoints/quotation-batches/quotation-batches";
import { listQuotations } from "../../../../../__generated__/orval/endpoints/quotations/quotations";
import { fetchUsers } from "../../../../../services/users";
import { buildListQuotationsParams } from "../../quotations/-queries";

export const quotationBatchDetailQueryOptions = (id: number | undefined) =>
  queryOptions({
    enabled: !!id,
    // biome-ignore lint/style/noNonNullAssertion: ID is checked in enabled
    queryFn: () => showQuotationBatch(id!),
    queryKey: ["quotationBatches", "detail", id],
  });

// Filters

export const userListQueryOptions = (ids: number[] | undefined) =>
  queryOptions({
    enabled: !!ids && ids.length > 0,
    queryFn: () => fetchUsers({ filters: { id: ids } }),
    queryKey: ["users", "list", ids],
    select: (data) => data.results,
    staleTime: 1000 * 60 * 5, // 5 minutes
  });

export const quotationsByIdsQueryOptions = (quotationIds: number[]) =>
  queryOptions({
    enabled: !!quotationIds && quotationIds.length > 0,
    queryFn: async () => {
      if (!quotationIds || quotationIds.length === 0) return [];
      const response = await listQuotations(
        buildListQuotationsParams({
          filters: { id: quotationIds },
          items_per_page: 1000,
        }),
      );
      return response.results;
    },
    queryKey: ["quotations", "byIds", quotationIds],
  });

export const batchVendorsQueryOptions = (params: {
  segments: number[];
  materialGroups: number[];
  brands: number[];
}) =>
  queryOptions({
    enabled:
      params.segments.length > 0 ||
      params.materialGroups.length > 0 ||
      params.brands.length > 0,
    queryFn: ({ signal }) =>
      getBatchVendors(
        {
          brands: params.brands,
          material_groups: params.materialGroups,
          segments: params.segments,
        },
        undefined,
        signal,
      ),
    queryKey: [
      "quotationBatches",
      "batchVendors",
      params.segments,
      params.materialGroups,
      params.brands,
    ],
  });
